<template>
  <div class="password-component">
    <input 
      type="password" 
      ref="passwordInput" 
      :name="name"
      :id="id"
      :value="modelValue" 
      class="form-control" 
      :class="{'form-control-sm': size == 'sm'}" 
      autocomplete="new-password" 
      :required="required"
    >
    <button type="button" @click="toggleInputType" aria-label="Toggle Password Visibility"></button>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: { require: true },
    required: { default: false},
    name: { default: null },
    id: { default: null },
    size: { default: null },
  },
  mounted() {
    this.$refs.passwordInput.oninput = (e) => {
      this.$emit('update:modelValue', e.target.value)
    }
  },
  methods: {
    toggleInputType() {
      const inputType = this.$refs['passwordInput'].getAttribute('type')

      if (inputType == 'password') {
        this.$refs['passwordInput'].setAttribute('type', 'text')
      } else {
        this.$refs['passwordInput'].setAttribute('type', 'password')
      }
    }
  }
}
</script>
